const cardsData = [
  {
    title: '51吃瓜本周最全合集',
    desc: '本周51吃瓜所有热门视频一次看完，从娱乐八卦到网红翻车应有尽有',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20entertainment%20video%20playlist%20concept%20with%20warm%20coral%20gradients%2C%20play%20button%20geometric%20motifs%2C%20modern%20streaming%20platform%20aesthetic%2C%20clean%20minimal%20composition&width=600&height=400&seq=cards-01&orientation=landscape',
    tag: '合集',
  },
  {
    title: '91吃瓜最新爆料速递',
    desc: '91吃瓜频道今日最新上线的劲爆内容，黑料吃瓜爱好者必看精选',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20breaking%20news%20concept%20with%20amber%20and%20orange%20gradients%2C%20bold%20exclamation%20geometric%20patterns%2C%20urgent%20editorial%20design%20style&width=600&height=400&seq=cards-02&orientation=landscape',
    tag: '速递',
  },
  {
    title: '网红圈黑料大起底',
    desc: '深度挖掘多位百万粉网红的真实面目，那些你不知道的黑料内幕全曝光',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20investigation%20and%20reveal%20concept%20with%20warm%20peach%20and%20deep%20coral%20tones%2C%20magnifying%20glass%20geometric%20motif%2C%20dramatic%20editorial%20photography%20style&width=600&height=400&seq=cards-03&orientation=landscape',
    tag: '深度',
  },
  {
    title: '娱乐圈经典名场面回顾',
    desc: '回顾那些年让人捧腹大笑的明星翻车名场面，每一帧都是经典表情包素材',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20funny%20and%20viral%20moment%20concept%20with%20warm%20orange%20gradients%2C%20playful%20geometric%20shapes%2C%20pop%20art%20inspired%20design%2C%20bold%20colors&width=600&height=400&seq=cards-04&orientation=landscape',
    tag: '经典',
  },
  {
    title: '某综艺暗箱操作全记录',
    desc: '从选手选拔到最终排名，全程揭秘热门综艺背后的资本博弈与暗箱操作',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20behind%20the%20scenes%20concept%20with%20warm%20amber%20and%20coral%20tones%2C%20curtain%20and%20shadow%20geometric%20motifs%2C%20mysterious%20editorial%20design&width=600&height=400&seq=cards-05&orientation=landscape',
    tag: '扒皮',
  },
  {
    title: '本月吃瓜热度排行榜TOP20',
    desc: '数据说话！本月全网吃瓜话题热度排名，看看哪些瓜最受大家关注讨论',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20ranking%20and%20leaderboard%20visual%20with%20warm%20coral%20pink%20gradients%2C%20ascending%20geometric%20bars%2C%20trophy%20motif%2C%20modern%20editorial%20design&width=600&height=400&seq=cards-06&orientation=landscape',
    tag: '榜单',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-3">
          <div className="w-8 h-8 rounded-lg bg-secondary-500 flex items-center justify-center">
            <i className="ri-layout-grid-line text-background-50 text-lg"></i>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">精品推荐</h2>
        </div>
        <p className="text-foreground-500 text-sm mb-8 md:mb-10">编辑精选的51吃瓜、91吃瓜优质内容，不容错过的吃瓜盛宴</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cardsData.map((item, i) => (
            <a
              key={i}
              href="#cards"
              onClick={(e) => e.preventDefault()}
              className="rounded-2xl overflow-hidden bg-background-100 hover:bg-background-200/70 transition-colors cursor-pointer group block"
            >
              <div className="aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => { const el = e.currentTarget.parentElement; if (el) el.style.display = 'none'; }}
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-[10px] font-bold text-primary-600 bg-primary-50 px-2 py-0.5 rounded">{item.tag}</span>
                </div>
                <h3 className="font-heading font-bold text-foreground-900 text-base mb-2 group-hover:text-primary-600 transition-colors">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}